import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DesktopContainer,
  LoadingSpinner,
} from '@rabbit/elements/shared-components';

import { OliveFileUploader } from '@rabbit/olive/components/organisms/upload-wrapper/OliveFileUploader';
import {
  DocTypeShapeTypes,
  UploadedFileCategories,
  DEFAULT_ACCEPTED_FILE_TYPES
} from '@rabbit/elements/shared-types';
import { t } from 'i18next';
import { AppContext } from '@rabbit/app-context';
import { useMyConsumerPersona } from '@rabbit/data/portal';

/* eslint-disable-next-line */
export interface HoldingSingleAddEditDocsProps {}

export function HoldingSingleAddEditDocs(props: HoldingSingleAddEditDocsProps) {
  const location = useLocation();
  const holdingId = location.pathname.split('/')[2];
  const navigate = useNavigate();
  const consumerPersona = useMyConsumerPersona();
  const consumerPersonaId = consumerPersona?.personaId;
  const { config } = useContext(AppContext);

  if (!consumerPersonaId) return <LoadingSpinner size="sm" />;

  return (
    <DesktopContainer
      title={t('Product documents')}
      goBack={() => navigate(-1)}
    >
      <OliveFileUploader
        label={t('Proof of purchase')}
        identifiers={{
          category: UploadedFileCategories.ConsumerProofPurchase,
          docType: { docid: holdingId, type: DocTypeShapeTypes.Holding },
          personaId: consumerPersonaId ?? '',
        }}
        shouldAutoUpdateDocs={true}
        accepts={DEFAULT_ACCEPTED_FILE_TYPES}
      />
      {config?.CLAIMS.CLAIMS_FLOW.SERIAL_NUMBER_PROOF && (
        <OliveFileUploader
          label={t('Photo of serial number')}
          identifiers={{
            category: UploadedFileCategories.SerialNumberProof,
            docType: { docid: holdingId, type: DocTypeShapeTypes.Holding },
            personaId: consumerPersonaId ?? '',
          }}
          allowDelete={false}
          shouldAutoUpdateDocs={true}
          maxFiles={1}
          accepts={DEFAULT_ACCEPTED_FILE_TYPES}
        />
      )}
    </DesktopContainer>
  );
}

export default HoldingSingleAddEditDocs;
